<agpr-dialog-container
    id="monitoringBulkActionDialog"
    heading="Monitoring.bulkActionDialog.header"
    (close)="closeDialog();"
    [contentPadding]="false"
>
    <div
        [agprLoading]="loading"
        class="agpr-monitoringBulkActionDialog-content"
    >
        <agpr-scroll-panel>
            <agpr-panel
                header="Monitoring.bulkActionDialog.actionHeader"
                [toggleable]="false"
                [ngClass]="{'agpr-monitoringBulkActionDialog-actionPanel' : !isUnsavedMentionType || selectedAction?.type !== actionType.export}"
            >
                <div class="agpr-monitoringBulkActionDialog-inputGroup">
                    <!-- Action picker -->
                    <agpr-dropdown
                        styleClass="agpr-monitoringBulkActionDialog-dropdown"
                        [options]="actionDropdownOptions"
                        [(ngModel)]="selectedActionOption"
                        [disabled]="totalMentionCount === 0"
                        (ngModelChange)="actionSelected($event.value)"
                        ariaLabel="Monitoring.bulkActionDialog.actionHeader"
                    >
                    </agpr-dropdown>
                </div>
                <ng-container #actionForm></ng-container>
                @if (!fetchingMentions && isUnsavedMentionType && selectedAction?.type === actionType.export) {
                    <div
                        class="agpr-monitoringBulkActionDialog-message"
                    >
                        <agpr-unsaved-export-info-message
                            [mentionCount]="totalMentionCount"
                            [unsavedMentionExportLimit]="unsavedMentionExportLimit"
                            [unsavedMentionQuotaUsage]="unsavedMentionQuotaUsage"
                            [remainingUnsavedMentionQuota]="remainingUnsavedMentionQuota"
                            [mentionType]="mentionType"
                        >
                        </agpr-unsaved-export-info-message>
                    </div>
                }
            </agpr-panel>
            <agpr-panel
                header="Monitoring.bulkActionDialog.dataSourceHeader"
                class="agpr-monitoringBulkActionDialog-dataPanel"
                [toggleable]="false"
            >
                <div class="agpr-monitoringBulkActionDialog-options" role="radiogroup">
                    <agpr-radio
                        id="monitoringBulkactionDialog.selectedCoverage"
                        label="Monitoring.bulkActionDialog.currentlySelectedCoverage"
                        hiddenLabel="Monitoring.bulkActionDialog.currentlySelectedCoverage"
                        name="mention_selection"
                        [(ngModel)]="sourceMethod"
                        (ngModelChange)="validateActionButton()"
                        [value]="sourceType.SELECTION"
                        [disabled]="mentionIds.length === 0 && mercuryIds.length === 0"
                    >
                    </agpr-radio>
                    <agpr-radio
                        id="monitoringBulkactionDialog.coverageFrom"
                        label="Monitoring.bulkActionDialog.coverageFrom"
                        hiddenLabel="Monitoring.bulkActionDialog.coverageFrom"
                        name="mention_selection"
                        [(ngModel)]="sourceMethod"
                        (ngModelChange)="validateActionButton()"
                        [value]="sourceType.SEARCH"
                    >
                    </agpr-radio>
                </div>
                <div
                    class="agpr-monitoringBulkActionDialog-optionsSourcePicker"
                    *ngIf="sourceMethod === sourceType.SEARCH"
                >
                    <agpr-monitoring-source-picker-with-facet-field
                        id="monitoringBulkactionDialog"
                        [field]="sourcePickerConfig"
                        [value]="sourcePickerDataSource"
                        (changes)="dataSourceChanged($event)"
                        [showHiddenOption]="true"
                    >
                    </agpr-monitoring-source-picker-with-facet-field>
                </div>
                <agpr-message
                    *ngIf="sourceMethod === sourceType.SELECTION"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ sourcePickerConfig.mentionCountLocalizationLabel | localize: {'number' : totalMentionCount } }}
                </agpr-message>
                <agpr-message
                    *ngIf="(selectedAction?.type === actionType.renormalize)"
                    [severity]="messageSeverityEnum.warning"
                >
                    {{ 'Monitoring.bulk.action.renormalize.warning' | localize }}
                </agpr-message>
            </agpr-panel>
        </agpr-scroll-panel>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.cancelButton'"
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="closeDialog()"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="selectedAction && selectedAction.buttonLabel"
            [id]="id + '.actionButton'"
            [style]="buttonTypes.primary"
            [disabled]="disableActionButton"
            [label]="selectedAction.buttonLabel"
            [ariaLabel]="selectedAction.buttonLabel"
            [tooltip]="disableActionButton ? selectedAction.disabledButtonTooltip : null"
            [ariaDescribedBy]="id + '_actionButton_disabledTooltip'"
            (click)="doAction()"
        ></agpr-button>
        <span
            [id]="id + '_actionButton_disabledTooltip'"
            class="u-srOnly"
        >
            {{ selectedAction ? (selectedAction.disabledButtonTooltip | localize) : '' }}
        </span>
    </ng-template>
</agpr-dialog-container>
